// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__zpDS5","rootSuccess":"CompleteLink_rootSuccess__2ron0","rootFailure":"CompleteLink_rootFailure__2EIxn","isDisabled":"CompleteLink_isDisabled__2iICE"};